import { AbstractJSONModel } from "./master-model";
export interface IEmploymentStatements {
  id: number;
  employment_id: number;
  other_time_hours_allocated: number | null | undefined;
  other_time_hours_used: number | null;
  other_time_hours: number | null;
  pool_hours_allocated: number | null;
  pool_hours_used: number;
  pool_hours: number;
  pool_hours_details: string;
  net_working_hours: number;
  supervision_hours_used: number;
  vacation_days_to_hold: number;
  vacation_days_held: number;
  sixth_week_days_to_hold: number;
  sixth_week_days_held: number;
  seniority_days_to_hold: number;
  seniority_days_held: number;
  conversion_factor: number;
  is_paid: boolean | null;
  date_of_statement: Date;
  created_at: Date | null;
  updated_at: Date | null;
  mon_fri_days: number;
  mon_fri_day_hours: number;
  public_holidays: number;
  public_holiday_hours: number;
  vacation_hours_to_hold: number;
  vacation_hours_held: number;
  sixth_week_hours_to_hold: number;
  sixth_week_hours_held: number;
  seniority_hours_to_hold: number;
  seniority_hours_held: number;
  transferred_time_hours: number | null;
}

export interface IEmploymentStatementsPost {
  employment_id: number;
  pool_hours_allocated: number | null;
  pool_hours_used: number;
  pool_hours: number;
  pool_hours_details: string;
  net_working_hours: number;
  supervision_hours_used: number;
  vacation_days_to_hold: number;
  vacation_days_held: number;
  sixth_week_days_to_hold: number;
  sixth_week_days_held: number;
  seniority_days_to_hold: number;
  seniority_days_held: number;
  date_of_statement: Date;
  mon_fri_days: number;
  mon_fri_day_hours: number;
  public_holidays: number;
  public_holiday_hours: number;
  vacation_hours_to_hold: number;
  vacation_hours_held: number;
  sixth_week_hours_to_hold: number;
  sixth_week_hours_held: number;
  seniority_hours_to_hold: number;
  seniority_hours_held: number;
  transferred_time_hours: number | null;
}

export interface IEmploymentStatementsPostOvertime extends IEmploymentStatementsPost {
  conversion_factor: number;
  is_paid: boolean | null;
}

export interface IEmploymentStatementsOK11Post extends IEmploymentStatementsPost {
  other_time_hours_allocated: number | null | undefined;
  other_time_hours_used: number | null;
  other_time_hours: number | null;
}

export interface IEmploymentStatementsOK11OvertimePost extends IEmploymentStatementsOK11Post {
  conversion_factor: number;
  is_paid: boolean | null;
}

export class EmploymentStatement extends AbstractJSONModel implements IEmploymentStatements {
  id = -1;
  employment_id = -1;
  other_time_hours_allocated: number | null | undefined = null;
  other_time_hours_used: number | null = null;
  other_time_hours: number | null = null;
  pool_hours_allocated: number | null = null;
  pool_hours_used = 0;
  pool_hours = 0;
  pool_hours_details = "";
  net_working_hours = 0;
  supervision_hours_used = 0;
  vacation_days_to_hold = 0;
  vacation_days_held = 0;
  sixth_week_days_to_hold = 0;
  sixth_week_days_held = 0;
  seniority_days_to_hold = 0;
  seniority_days_held = 0;
  conversion_factor = 0;
  is_paid: boolean | null = null;
  date_of_statement: Date = new Date();
  created_at: Date | null = null;
  updated_at: Date | null = null;
  mon_fri_days = 0;
  mon_fri_day_hours = 0;
  public_holidays = 0;
  public_holiday_hours = 0;
  vacation_hours_to_hold = 0;
  vacation_hours_held = 0;
  sixth_week_hours_to_hold = 0;
  sixth_week_hours_held = 0;
  seniority_hours_to_hold = 0;
  seniority_hours_held = 0;
  transferred_time_hours: number | null = null;

  employeeId = -1;

  equals(other: IEmploymentStatements): boolean {
    return other.id === this.id;
  }

  public convertToPostObject(): IEmploymentStatementsPost {
    const es: IEmploymentStatementsPost = Object.assign({});
    es.date_of_statement = this.date_of_statement;
    es.employment_id = this.employment_id;
    es.mon_fri_day_hours = this.mon_fri_day_hours;
    es.mon_fri_days = this.mon_fri_days;
    es.net_working_hours = this.net_working_hours;
    es.pool_hours = this.pool_hours;
    es.pool_hours_allocated = this.pool_hours_allocated;
    es.pool_hours_details = this.pool_hours_details;
    es.pool_hours_used = this.pool_hours_used;
    es.public_holiday_hours = this.public_holiday_hours;
    es.public_holidays = this.public_holidays;
    es.seniority_days_held = this.seniority_days_held;
    es.seniority_days_to_hold = this.seniority_days_to_hold;
    es.seniority_hours_held = this.seniority_hours_held;
    es.seniority_hours_to_hold = this.seniority_hours_to_hold;
    es.supervision_hours_used = this.supervision_hours_used;
    es.vacation_days_held = this.vacation_days_held;
    es.vacation_days_to_hold = this.vacation_days_to_hold;
    es.vacation_hours_held = this.vacation_hours_held;
    es.vacation_hours_to_hold = this.vacation_hours_to_hold;
    es.sixth_week_days_held = this.sixth_week_days_held;
    es.sixth_week_days_to_hold = this.sixth_week_days_to_hold;
    es.sixth_week_hours_held = this.sixth_week_hours_held;
    es.sixth_week_hours_to_hold = this.sixth_week_hours_to_hold;
    es.transferred_time_hours = this.transferred_time_hours;
    return es;
  }

  public convertToPostOvertimeObject(): IEmploymentStatementsPostOvertime {
    const es: IEmploymentStatementsPostOvertime = Object.assign({});
    es.conversion_factor = this.conversion_factor;
    es.is_paid = this.is_paid;
    es.transferred_time_hours = this.transferred_time_hours;
    es.date_of_statement = this.date_of_statement;
    es.employment_id = this.employment_id;
    es.mon_fri_day_hours = this.mon_fri_day_hours;
    es.mon_fri_days = this.mon_fri_days;
    es.net_working_hours = this.net_working_hours;
    es.pool_hours = this.pool_hours;
    es.pool_hours_allocated = this.pool_hours_allocated;
    es.pool_hours_details = this.pool_hours_details;
    es.pool_hours_used = this.pool_hours_used;
    es.public_holiday_hours = this.public_holiday_hours;
    es.public_holidays = this.public_holidays;
    es.seniority_days_held = this.seniority_days_held;
    es.seniority_days_to_hold = this.seniority_days_to_hold;
    es.seniority_hours_held = this.seniority_hours_held;
    es.seniority_hours_to_hold = this.seniority_hours_to_hold;
    es.supervision_hours_used = this.supervision_hours_used;
    es.vacation_days_held = this.vacation_days_held;
    es.vacation_days_to_hold = this.vacation_days_to_hold;
    es.vacation_hours_held = this.vacation_hours_held;
    es.vacation_hours_to_hold = this.vacation_hours_to_hold;
    es.sixth_week_days_held = this.sixth_week_days_held;
    es.sixth_week_days_to_hold = this.sixth_week_days_to_hold;
    es.sixth_week_hours_held = this.sixth_week_hours_held;
    es.sixth_week_hours_to_hold = this.sixth_week_hours_to_hold;
    return es;
  }

  public convertToPostHourlyPaidOvertimeObject(): IEmploymentStatementsPostOvertime {
    const es: IEmploymentStatementsPostOvertime = Object.assign({});
    es.conversion_factor = this.conversion_factor;
    es.is_paid = this.is_paid;
    es.date_of_statement = this.date_of_statement;
    es.employment_id = this.employment_id;
    es.pool_hours = this.pool_hours;
    es.pool_hours_allocated = this.pool_hours_allocated;
    es.pool_hours_details = this.pool_hours_details;
    es.pool_hours_used = this.pool_hours_used;
    es.supervision_hours_used = this.supervision_hours_used;
    return es;
  }

  public convertToPostOK11OvertimeObject(): IEmploymentStatementsOK11OvertimePost {
    const es: IEmploymentStatementsOK11OvertimePost = Object.assign({});
    es.conversion_factor = this.conversion_factor;
    es.is_paid = this.is_paid;
    es.transferred_time_hours = this.transferred_time_hours;
    es.date_of_statement = this.date_of_statement;
    es.employment_id = this.employment_id;
    es.mon_fri_day_hours = this.mon_fri_day_hours;
    es.mon_fri_days = this.mon_fri_days;
    es.net_working_hours = this.net_working_hours;
    es.other_time_hours = this.other_time_hours;
    es.other_time_hours_allocated = this.other_time_hours_allocated;
    es.other_time_hours_used = this.other_time_hours_used;
    es.pool_hours = this.pool_hours;
    es.pool_hours_allocated = this.pool_hours_allocated;
    es.pool_hours_details = this.pool_hours_details;
    es.pool_hours_used = this.pool_hours_used;
    es.public_holiday_hours = this.public_holiday_hours;
    es.public_holidays = this.public_holidays;
    es.seniority_days_held = this.seniority_days_held;
    es.seniority_days_to_hold = this.seniority_days_to_hold;
    es.seniority_hours_held = this.seniority_hours_held;
    es.seniority_hours_to_hold = this.seniority_hours_to_hold;
    es.supervision_hours_used = this.supervision_hours_used;
    es.vacation_days_held = this.vacation_days_held;
    es.vacation_days_to_hold = this.vacation_days_to_hold;
    es.vacation_hours_held = this.vacation_hours_held;
    es.vacation_hours_to_hold = this.vacation_hours_to_hold;
    es.sixth_week_days_held = this.sixth_week_days_held;
    es.sixth_week_days_to_hold = this.sixth_week_days_to_hold;
    es.sixth_week_hours_held = this.sixth_week_hours_held;
    es.sixth_week_hours_to_hold = this.sixth_week_hours_to_hold;
    return es;
  }

  public convertToOK11PostObject(): IEmploymentStatementsOK11Post {
    const es: IEmploymentStatementsOK11Post = Object.assign({});
    es.date_of_statement = this.date_of_statement;
    es.employment_id = this.employment_id;
    es.mon_fri_day_hours = this.mon_fri_day_hours;
    es.mon_fri_days = this.mon_fri_days;
    es.net_working_hours = this.net_working_hours;

    es.other_time_hours = this.other_time_hours;
    es.other_time_hours_allocated = this.other_time_hours_allocated;
    es.other_time_hours_used = this.other_time_hours_used;

    es.pool_hours = this.pool_hours;
    es.pool_hours_allocated = this.pool_hours_allocated;
    es.pool_hours_details = this.pool_hours_details;
    es.pool_hours_used = this.pool_hours_used;
    es.public_holiday_hours = this.public_holiday_hours;
    es.public_holidays = this.public_holidays;
    es.seniority_days_held = this.seniority_days_held;
    es.seniority_days_to_hold = this.seniority_days_to_hold;
    es.seniority_hours_held = this.seniority_hours_held;
    es.seniority_hours_to_hold = this.seniority_hours_to_hold;
    es.supervision_hours_used = this.supervision_hours_used;
    es.vacation_days_held = this.vacation_days_held;
    es.vacation_days_to_hold = this.vacation_days_to_hold;
    es.vacation_hours_held = this.vacation_hours_held;
    es.vacation_hours_to_hold = this.vacation_hours_to_hold;
    es.sixth_week_days_held = this.sixth_week_days_held;
    es.sixth_week_days_to_hold = this.sixth_week_days_to_hold;
    es.sixth_week_hours_held = this.sixth_week_hours_held;
    es.sixth_week_hours_to_hold = this.sixth_week_hours_to_hold;
    return es;
  }
}
